import { render, staticRenderFns } from "./home-on-boarding-card.vue?vue&type=template&id=d6d57064&"
import script from "./home-on-boarding-card.vue?vue&type=script&lang=ts&"
export * from "./home-on-boarding-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports